import React from "react";
import { useTheme } from "react-jss";
import useStyles from "./TableFooter.styles";
import { PaginatedTableProps } from "./PaginatedTable";
import { TablePagination } from "./TablePagination";
import { TinySelect } from "../select/TinySelect";
import Button from "../shared/Button";
interface FooterProps {
    children: React.ReactNode;
    rowsPerPage: number;
    tableProps: PaginatedTableProps;
    currentPage: number;
    pageCount: number;
    lengthMenuText: string;
    isShowRowsPerPage?: boolean;
    isShowPageInfo?: boolean;
    isAddNewItem?: boolean;
    newItemLabel?: string;
    onChangeRowsPerPage(value: number);
    onItemAdd?(): void;
    isShowPagination?: boolean;
}

export function TableFooter(props: FooterProps) {
    const {
        children,
        rowsPerPage,
        tableProps,
        onChangeRowsPerPage,
        currentPage,
        pageCount,
        lengthMenuText,
        isShowRowsPerPage = true,
        isShowPageInfo = true,
        isAddNewItem,
        onItemAdd,
        newItemLabel,
        isShowPagination = true,
    } = props;
    const { rowsPerPageOptions } = tableProps;
    const theme = useTheme();
    const classes = useStyles({ theme });
    const [displayText, itemsText] = lengthMenuText.split("_MENU_");
    return (
        <div className={classes.footer}>
            {isShowPagination && (
                <>
                    {isShowPageInfo && (
                        <div className={classes.pageInfo} role="status" aria-live="polite">
                            {children}
                        </div>
                    )}
                    {isShowRowsPerPage && (
                        <>
                            <div className={classes.flex} />
                            <div className={classes.rowsPerPage}>
                                {displayText}
                                <TinySelect
                                    value={String(rowsPerPage)}
                                    options={rowsPerPageOptions.map(String)}
                                    onChange={(value) => onChangeRowsPerPage(parseInt(value, 10))}
                                />
                                {itemsText}
                            </div>
                        </>
                    )}
                    <TablePagination
                        currentPage={currentPage}
                        pageCount={pageCount}
                        rowsPerPage={rowsPerPage}
                        tableProps={tableProps}
                    />
                </>
            )}
            {isAddNewItem && (
                <>
                    <div className={classes.flex} />
                    <Button
                        icon={["far", "plus"]}
                        iconPosition="start"
                        text={newItemLabel}
                        onClick={onItemAdd}
                    />
                </>
            )}
        </div>
    );
}
